export default function StatsSection() {
  const stats = [
    { label: '收录漫画', value: '5,800+', suffix: '部' },
    { label: '每日更新', value: '200+', suffix: '话' },
    { label: '注册用户', value: '200万+', suffix: '人' },
    { label: '累计阅读', value: '3.8亿+', suffix: '次' },
  ];

  return (
    <section className="py-14 md:py-20 bg-accent-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block bg-white/80 text-foreground-700 text-xs font-medium px-4 py-1.5 rounded-full whitespace-nowrap">
              平台数据
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mt-4">
              韩漫之家 · 值得信赖的<br />
              <span className="text-foreground-500 font-light">韩漫阅读平台</span>
            </h2>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            {stats.map((stat, idx) => (
              <div key={idx} className="flex flex-col items-center gap-2">
                <div className="flex items-baseline gap-1">
                  <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
                    {stat.value}
                  </span>
                  <span className="text-sm text-foreground-500">{stat.suffix}</span>
                </div>
                <p className="text-sm text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}